module.exports = __webpack_public_path__ + "static/media/Onions.0a927be3.png";